import React from 'react';
import { CircleBadge, CircleBadgeColor } from '../../../../CircleBadge';
import { ThreeDots } from 'react-bootstrap-icons';
import ReactTooltip from 'react-tooltip';

interface NoDocumentBadgeProps {
  id: string;
  column: string;
}
const NoDocumentBadge = ({ id, column }: NoDocumentBadgeProps) => {
  return (
    <>
      <CircleBadge
        child={ThreeDots}
        color={CircleBadgeColor.GREY}
        dataFor={`no-documents-badge-${id}`}
        dataTip
      />
      <ReactTooltip id={`no-documents-badge-${id}`} effect="solid">
        <div className="mb-1">{`No ${column} document`}</div>
      </ReactTooltip>
    </>
  );
};

export default NoDocumentBadge;
